import * as firebase from "firebase";
import firestore from "firebase/firestore";

const settings = {};

const config = {
  apiKey: "AIzaSyCOmqSq4T4sK4BUW9fDn0GX9I8IXyBv0ZU",
  authDomain: "telerx-8fd97.firebaseapp.com",
  databaseURL: "https://telerx-8fd97.firebaseio.com",
  projectId: "telerx-8fd97",
  storageBucket: "telerx-8fd97.appspot.com",
  messagingSenderId: "221529168253",
  appId: "1:221529168253:web:0591db25703e253cf4d414",
  measurementId: "G-JL5QP72PN2"
};
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;
